export const VERTEX_SHADER = `
attribute vec2 aPosition;
varying vec2 vUv;
void main() {
    vUv = aPosition * 0.5 + 0.5;
    gl_Position = vec4(aPosition, 0.0, 1.0);
}
`;

export const FRAGMENT_SHADER = `
precision mediump float;
uniform sampler2D uTexture;
uniform vec2 uResolution;
uniform float uDpr;
uniform float uTime;
uniform float uScan;
uniform float uCurve;
uniform float uNoise;
uniform float uOn;
varying vec2 vUv;

const float TAU = 6.28318;
const float SCAN_PERIOD = 4.0;
const float TRIAD_WIDTH = 3.0;

float hash(vec2 p) {
    return fract(sin(dot(p, vec2(12.9898, 78.233))) * 43758.5453);
}

// 유리 곡면: 가장자리로 갈수록 래스터가 휜다
vec2 barrel(vec2 uv) {
    vec2 c = uv * 2.0 - 1.0;
    c *= 1.0 + dot(c, c) * vec2(0.055, 0.09) * uCurve;
    return c * 0.5 + 0.5;
}

void main() {
    if (uOn < 0.5) {
        gl_FragColor = vec4(texture2D(uTexture, vUv).rgb, 1.0);
        return;
    }

    vec2 uv = barrel(vUv);
    vec2 fringe = vec2(0.0009, 0.0);
    vec3 color = vec3(
        texture2D(uTexture, uv + fringe).r,
        texture2D(uTexture, uv).g,
        texture2D(uTexture, uv - fringe).b
    );
    float luma = max(color.g, 0.05) * 1.6;

    // 주사선과 애퍼처 그릴은 휘어진 좌표를 따른다
    float cssY = uv.y * uResolution.y / uDpr;
    float scan = 0.5 + 0.5 * cos(TAU * cssY / SCAN_PERIOD);
    color *= 1.0 - uScan * 0.72 * (1.0 - scan) * (1.0 - luma * 0.45);

    float cssX = gl_FragCoord.x / uDpr;
    vec3 triad = max(cos(TAU * (cssX / TRIAD_WIDTH + vec3(0.0, 0.33, 0.67))), 0.0);
    color *= 1.0 - uScan * 0.34 * (1.0 - triad);

    // 꺼진 인광체도 살짝 빛나고, 정전기 잡음이 얹힌다
    color += vec3(0.010, 0.024, 0.017);
    color += (hash(gl_FragCoord.xy * 0.73 + fract(uTime) * 91.0) - 0.5) * 0.08 * uNoise;

    // 위로 천천히 지나가는 재생 띠와 미세한 깜빡임
    float band = exp(-pow((fract(uv.y - uTime * 0.055) - 0.5) * 8.0, 2.0));
    color *= 1.0 + band * 0.14;
    color += vec3(0.0, 0.016, 0.011) * band;
    color *= 1.0 + sin(uTime * 113.0) * 0.008;

    // 유리 가장자리 감광
    // 튜브 밖 좌표는 음수라 두 축이 함께 밖이면 곱이 양수가 된다. 먼저 0으로 막는다
    vec2 edge = max(uv * (1.0 - uv), 0.0);
    color *= pow(clamp(edge.x * edge.y * 16.0, 0.0, 1.0), 0.3);

    gl_FragColor = vec4(color, 1.0);
}
`;
